const state = () => ({
  patientData: null,
});

const getters = {};

const actions = {
  setPatientData({ commit }, patientData) {
    commit("setPatientData", patientData);
  },
};

const mutations = {
  setPatientData(state, patientData) {
    state.patientData = patientData;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
